import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import { canlenderFilter, columns, data, filters, searchBy } from "../../../service/OrderService.js";
import { useFetchAll } from "../../../custom/FetchApiHook";
import OrderApi from "../../../App/api/order.apis";
import OrderModal from "./OrderModal/OrderModal.jsx";
import { useNavigate } from "react-router";
import StoreModal from "../../../Components/Modals/StoreModal/StoreModal.jsx";
import { toast } from "react-toastify";
import TogglesList from "../../Settings/components/TogglesList.jsx";



const OrderComp = ({disabledFilters,pagination,handlePagination}) => {
  const [search,setSearch]=useState("")
  const [value,setValue]=useState("")
  const [activeType, setActiveType] = useState('ecommerce');
  const debounceTimeout = useRef(null); 

 const OrderDataFun = async () => {
   try {
     const res = await OrderApi.getAllOrders(
       pagination ? pagination : {},
       search
     );

     // console.log("Operation successful:", type,res.data.data);
     setValue(res.data);
     return res; // Optional: Return the result if needed
   } catch (error) {
     console.error("An error occurred:", error);
   }
 };


  
  // 
  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const navigate=useNavigate()
  // console.log("value orderComp",value);
 
  // const {page,totalCount,totalPages,limit}=value.data
  const handleCloseOrderModal=()=>{

    setIsOrderDetail(false);
    setSelectedOrder(null);
  }
  const handleRowClick = (row) => {
    // console.log("row", row);
    setSelectedOrder(row);
    setIsOrderDetail(true);
  };
  const handleCellClick =async (cell,field="") => {
    console.log("click on profile:",field);
    console.log("cell", cell);

    if (field==="order_id") {      
      setSelectedOrder(cell);
      setIsOrderDetail(true);
    }
    if (field==="vendor") {            
     setVendorData(cell)
    }
    if (field.vendor_action) {
      const payload={
        orderId:cell._id,
        vendor_action:field.vendor_action
      }
      try {
      const res = await  OrderApi.updateOrders(payload)
      console.log("updateOrders::res",res);
      OrderDataFun()
      
      toast.success(`Order ${res?.data?.data?.delivery_status}`)
      
      } catch (error) {
        console.log(error);
        
      }
    }
  };

 

  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked",e);
     //  const row={
     //   filters: null,
     //   first: 0,
     //   multiSortMeta: [],
     //   page: 0,
     //   rows: 10,
     //   sortField: null,
     //   sortOrder: null,
     //   totalPages: 2   
     // }
     const data={
      limit:e.rows,
      page:+e.page+1
     }
     handlePagination && handlePagination(data)
     // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
    }
  
  };

  const handleSearch = useCallback((s) => {
    console.log('Search at OrderCom', s);
    setSearch(s);
}, []);

const debouncedSearch = useCallback((s) => {
  if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
  } 
  debounceTimeout.current = setTimeout(() => {
      handleSearch(s); 
  }, 1500);
}, [handleSearch]);


const handleClearFilter=()=>{
const clearPagination=  {
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  }
  // console.log('clearPagination',clearPagination);
  handlePagination && handlePagination({clearPagination})
}
const handleFilter=(name,value)=>{
console.table('name,value',name,value);
let data={}
if (name==='search_by') {
  data.sortOrder=value.code
}
else{
 
  const filter={}
  filter[`${name}`]=value.code?value.code:value
  data.filter=filter
  
}

// console.log('data',data);
 handlePagination && handlePagination(data)


}
const toggleJson = [
  "Ecommerce",
  "Restaurant",
]
  // console.log("pagination",pagination);
  // console.log("search",search);
  // console.log("filters",filters);
  // console.log("debouncedSearch",debouncedSearch);
  

  useEffect(() => {
    OrderDataFun()
  }, [pagination,search,activeType]);

  const DataFilter=filters.filter((f)=>disabledFilters?!disabledFilters.includes(f.inputName):true)

  return (
    <div className="p-5">   
{/*    
      <div className=" p-6 flex justify-start gap-4">
        <p onClick={()=>setActiveType('ecommerce')} 
        className={`text-lg cursor-pointer ${
          activeType === 'ecommerce' ? 'border-b-2 border-red-500 text-red-500' : ''
        }`}>Ecommerce</p>

        <p onClick={()=>setActiveType('restaurant')} 
        className={`text-lg cursor-pointer ${
          activeType === 'restaurant' ? 'border-b-2 border-red-500 text-red-500' : ''
        }`}>Restaurant</p>
      </div>   */}
      <BasicTable
        // data={[]}

        columns={columns(activeType)}
        data={value?.data?.orders}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page||1,
          rows: value?.data?.limit||5,
          sortField: null,
          sortOrder: null,
          totalPages: value.data?.totalPages||1  ,
          totalCount: value.data?.totalCount||1  
        }}
        onCellClick={(e)=>{console.log("Cell Data",e)}}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name,value)=>handleFilter(name,value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        WeekRange={false}
        MonthRange={true}
        canlenderFilter={canlenderFilter}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
        // handleRowClick={(row) => handleRowClick(row)}
      />
      <OrderModal
      handleRowClick={handleRowClick}
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        orderData={selectedOrder}
        OrderDataFun={OrderDataFun}
      />
      <StoreModal
        itemData={vendorData}
          setToggleUsersDetails={(v)=>{setVendorData(null)}}
          toggleUsersDetails={Boolean(vendorData)}
        />
    </div>
  );
};

export default OrderComp;


